<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p><a id="pl-3-3"></a></p>
<p class="copytop">Text and artwork ©2003 Ricky Tims</p>
<p class="copyt">E<span class="small">DITOR</span>-<span class="small">IN</span>-C<span class="small">HIEF</span>: <i>Dana Williamson</i></p>
<p class="copyt">E<span class="small">DITOR</span>: <i>Cyndy Lyle Rymer</i></p>
<p class="copyt">T<span class="small">ECHNICAL</span> E<span class="small">DITOR</span>: <i>Sara Kate MacFarland</i></p>
<p class="copyt">C<span class="small">OPY</span> E<span class="small">DITOR</span>/P<span class="small">ROOFREADER</span>: <i>Lee Jonsson/Joyce E. Lytle/Eva Simoni Er</i>b</p>
<p class="copyt">C<span class="small">OVER</span> D<span class="small">ESIGNER</span>: <i>Christina farumay</i></p>
<p class="copyt">D<span class="small">ESIGN</span> D<span class="small">IRECTOR</span>/B<span class="small">OOK</span> D<span class="small">ESIGNER</span>: <i>Rose Shelter</i></p>
<p class="copyt">I<span class="small">LLUSTRATOR</span>: <i>Kirstie L. McCormick</i></p>
<p class="copyt">P<span class="small">RODUCTION</span> A<span class="small">SSISTANT</span>: <i>Jetfery Carrillo</i></p>
<p class="copyt">P<span class="small">HOTOGRAPHY</span>: Quilt photography by John Bonath, Maddog Studio, Denver, CO; Digital photos by Ricky Tims and Justin Shults unless otherwise noted</p>
<p class="copyt">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, California, 94549</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0003_copyrighttitle.vue?1f484dcb